<template>
  <el-container class="app-wrapper">
    <!-- 侧边栏 -->
    <el-aside width="200px" class="sidebar-container">
      <div class="logo">
        <h2>车辆检测管理系统</h2>
      </div>
      <el-menu
        :default-active="$route.path"
        class="sidebar-menu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router
      >
        <el-menu-item index="/vehicles">
          <i class="el-icon-truck"></i>
          <span slot="title">车辆管理</span>
        </el-menu-item>
        <el-menu-item index="/reports">
          <i class="el-icon-document"></i>
          <span slot="title">检测报告管理</span>
        </el-menu-item>
        <el-menu-item index="/images">
          <i class="el-icon-picture"></i>
          <span slot="title">图片管理</span>
        </el-menu-item>
        <el-menu-item index="/settings">
          <i class="el-icon-bell"></i>
          <span slot="title">温馨提示管理</span>
        </el-menu-item>
        <el-menu-item index="/guarantee">
          <i class="el-icon-star-on"></i>
          <span slot="title">保障管理</span>
        </el-menu-item>
        <el-menu-item index="/inspection-item">
          <i class="el-icon-s-check"></i>
          <span slot="title">检测项目管理</span>
        </el-menu-item>
        <el-menu-item index="/inspection-template">
          <i class="el-icon-document-copy"></i>
          <span slot="title">检测项模板管理</span>
        </el-menu-item>
        <el-menu-item index="/vehicle-brand">
          <i class="el-icon-star-off"></i>
          <span slot="title">车辆品牌管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <!-- 主内容区 -->
    <el-container>
      <!-- 顶部导航 -->
      <el-header class="app-header">
        <div class="header-left">
          <h3>{{ $route.meta.title }}</h3>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              管理员 <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 内容区 -->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'Layout',
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 清除登录状态
          localStorage.removeItem('token')
          this.$router.push('/login')
        }).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.app-wrapper {
  height: 100vh;
}

.sidebar-container {
  background-color: #304156;
  color: #bfcbd9;
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2b2f3a;
  color: #fff;
}

.logo h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.sidebar-menu {
  border: none;
}

.app-header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.header-left h3 {
  margin: 0;
  color: #303133;
}

.header-right {
  display: flex;
  align-items: center;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.app-main {
  background-color: #f0f2f5;
  padding: 20px;
}
</style>